module.exports = {
  dish1: {
    name: "Wine 1",
    description: "Insert Wine 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Wine 2",
    description: "Insert Wine 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Wine 3",
    description: "Insert Wine 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Wine 4",
    description: "Insert Wine 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Wine 5",
    description: "Insert Wine 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Wine 6",
    description: "Insert Wine 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Wine 7",
    description: "Insert Wine 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Wine 8",
    price: 4400,
    description: "Insert Wine 8 description",
    status: "available"
  },
  dish9: {
    name: "Wine 9",
    price: 3300,
    description: "Insert Wine 9 description",
    status: "available"
  },
  dish10: {
    name: "Wine 10",
    price: 3900,
    description: "Insert Wine 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/CyberCellar.js